import { PlatformLocation } from "@angular/common";
import { ChangeDetectorRef, Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  ActivatedRoute,
  Router,
  Event,
  NavigationStart,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
} from "@angular/router";
import { MessageService } from "primeng/api";
import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth/services/auth.service";
import { ThemeVariables, ThemeRef, lyl, StyleRenderer } from "@alyle/ui";

const STYLES = (theme: ThemeVariables, ref: ThemeRef) => {
  return {
    $global: lyl`{
      body {
        background-color: ${theme.background.default}
        color: ${theme.text.default}
        font-family: ${theme.typography.fontFamily}
        margin: 0
        direction: ${theme.direction}
      }
    }`,
    root: lyl`{
      display: block
    }`,
  };
};

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  providers: [MessageService, StyleRenderer],
})
export class AppComponent {
  readonly classes = this.sRenderer.renderSheet(STYLES, true);

  currentUrl;
  IsMemberPrivilagePlan = false;
  public showLoadingIndicator: boolean = true;
  subscription: Subscription;
  favIcon: HTMLLinkElement = document.querySelector("#appIcon");

  constructor(
    readonly sRenderer: StyleRenderer,
    public auth: AuthService,
    private router: Router,
    location: PlatformLocation,
    private cdrRef: ChangeDetectorRef,
    private titleService: Title
  ) {
    this.router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        window.scroll(0, 0);
        this.showLoadingIndicator = true;
        location.onPopState(() => {
          window.location.reload();
        });
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
        if (
          this.currentUrl.trim() === "membership-privilage-form" ||
          this.currentUrl.trim().split("?")[0] === "membership-privilage-form"
          || this.currentUrl.trim() === 'membership-dashboard-breakdown-details' || this.currentUrl.trim().split('?')[0] === 'membership-dashboard-breakdown-details'
        ) {
          this.IsMemberPrivilagePlan = true;
        } else {
          this.IsMemberPrivilagePlan = false;
        }
      }
      if (
        routerEvent instanceof NavigationEnd ||
        routerEvent instanceof NavigationCancel ||
        routerEvent instanceof NavigationError
      ) {
        this.showLoadingIndicator = false;
      }
    });
  }

  ngOnInit() {
    this.titleService.setTitle(environment.clinicName + " Admin");
    this.favIcon.href = environment.favIcon;
  }

  ngAfterViewInit() {
    this.auth.loginStatusChanges();
    this.cdrRef.detectChanges();
    document.documentElement.style.setProperty(
      "--primary-color",
      environment.primaryColor
    );
    document.documentElement.style.setProperty(
      "--secondary-color",
      environment.secondaryColor
    );
  }
}
